var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadcrumbs
    }
  }), _vm.loading ? [_c('Loader', {
    attrs: {
      "content-id": _vm.blockId,
      "message": 'Fetching Block Details'
    }
  })] : [!_vm.block ? _c('HTTPError', {
    attrs: {
      "id": _vm.blockId,
      "title": 'Block Details Not Found',
      "message": 'A record for this block was not found in the Avalanche Explorer',
      "support-u-r-l": 'https://chat.avalabs.org'
    }
  }) : [_c('EVMBlockSummary', {
    attrs: {
      "block": _vm.block
    }
  }, [_vm._v(" EVM Block ")])]]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }